import { types, actions } from './requests'
export const DELETEBLACKBOX_TYPES = {
    ...types('DELETEBLACKBOX'),
}
export const DELETEBLACKBOX_ACTIONS = {
    ...actions('DELETEBLACKBOX'),
}
